import Factory from '@/Factories/Factory';
import ComponentManager from '@/Management/ComponentManager';
import { FactoryParameter } from '#/CoreFrameInterfaces';
import { IInlineEditingUIGeneratorReplacerCallback, IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';

export default class InlineEditingGridManager {

    private static readonlyPrinter: IReadOnlyPrinterStatic[] = [];

    private static replacer: { [key: string]: IInlineEditingUIGeneratorReplacerCallback } = {};

    private static textColumnFactories: string[] = [];

    public static registerReadOnlyPrinter(printer: IReadOnlyPrinterStatic) {
        InlineEditingGridManager.readonlyPrinter.push(printer);
    }

    public static getPrinter(item: IDVGItemDTO, value: string, row: IGenericDTO): IReadOnlyPrinterStatic {
        const index = _.findIndex(InlineEditingGridManager.readonlyPrinter, x => x.isRelevant(item, value, row));
        if (index === -1)
            return null;
        
        return InlineEditingGridManager.readonlyPrinter[index];
    }

    public static registerUIGeneratorReplacer(factory: string, replaceFactory: string, keepParams: boolean = true): void {
        InlineEditingGridManager.replacer[factory] = (parameter: FactoryParameter) => {
            parameter.uiGenerator = replaceFactory;
            if (!keepParams)
                parameter.parameters = {};

            return parameter;
        };
    }

    public static registerUIGeneratorReplacerCallback(factory: string, callback: IInlineEditingUIGeneratorReplacerCallback): void {
        InlineEditingGridManager.replacer[factory] = callback;
    }

    public static replaceUIGenerator(item: IDVGItemDTO): void {
        const params = Factory.parseUIGeneratorQuery(item.uiGenerator);
        const replacer = InlineEditingGridManager.replacer[params.uiGenerator];

        if(!Utilities.isNullOrUndefined(replacer))
            item.uiGenerator = Factory.toUIGeneratorQuery(replacer(params, item));        

        item.children.forEach(x => InlineEditingGridManager.replaceUIGenerator(x));
    }

    public static registerTextColumnFactory(factory: string): void {
        InlineEditingGridManager.textColumnFactories.push(factory);
    }

    public static isTextColumnFactory(uiGenerator: string): boolean {
        const params = Factory.parseUIGeneratorQuery(uiGenerator);

        return InlineEditingGridManager.textColumnFactories.indexOf(params.uiGenerator) > -1;
    }
}

ComponentManager.setUtility('InlineEditingGridManager', InlineEditingGridManager, 'RADPresentation.HTMLClient.DefaultViewExtensions');